import React, { useEffect, useRef, useState } from 'react';
import { DateRange as ReactDateRange, DefinedRange } from 'react-date-range';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { pt } from 'date-fns/locale';
import { useField } from 'formik';
import moment from 'moment';

import useOnClick from '~/pages/utils/useOnClick';
import colors from '~/styles/colors';

import { STATIC_RANGES } from './StaticRanges';
import { Container, Content, ErrorSpan, DefinedRangeContainer } from './styles';

export type DateRangeValues = Array<{
  startDate: Date | null;
  endDate: Date | null;
  key: 'selection';
}>;

type DateRangeProps = {
  name: string;
  hideCalendar?: boolean;
  definedRange?: boolean;
  defaultValue?: DateRangeValues;
};

const DateRange: React.FC<DateRangeProps> = ({
  name,
  hideCalendar,
  definedRange,
  defaultValue,
}) => {
  const [colorSet, setColorSet] = useState<string[]>(['transparent']);
  const [focus, setFocus] = useState<boolean>(false);

  const datePickerRef = useRef(null);
  const [field, meta, helpers] = useField<DateRangeValues>(name);
  const { value: state } = field;
  const { error } = meta;
  const { setValue } = helpers;

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state && (state[0].startDate || state[0].endDate)) {
      setColorSet([colors.primary]);
    } else {
      setColorSet(['transparent']);
    }
  }, [state]);

  useOnClick(
    datePickerRef,
    () => setFocus(false),
    () => setFocus(true),
  );

  return (
    <Container>
      <Content
        disableRangeSelect={colorSet[0] === 'transparent'}
        hideCalendar={hideCalendar && focus === false}
        ref={datePickerRef}
      >
        <ReactDateRange
          showMonthAndYearPickers={false}
          dateDisplayFormat="dd/MM/yyyy"
          startDatePlaceholder="Início"
          endDatePlaceholder="Fim"
          editableDateInputs
          onChange={(item: any) => {
            setValue([
              {
                startDate: moment(item.selection.startDate)
                  .startOf('day')
                  .toDate(),
                endDate: moment(item.selection.endDate).endOf('day').toDate(),
                key: 'selection',
              },
            ]);
          }}
          moveRangeOnFirstSelection={false}
          ranges={state as any}
          rangeColors={colorSet}
          locale={pt}
        />
        {error && <ErrorSpan>error</ErrorSpan>}
      </Content>
      {definedRange && (
        <DefinedRangeContainer>
          <DefinedRange
            onChange={(item: any) => setValue([item.selection])}
            ranges={state as any}
            staticRanges={STATIC_RANGES}
          />
        </DefinedRangeContainer>
      )}
    </Container>
  );
};

export default DateRange;
